const geometry = require("../geometry");
const utils = require("../utils");

/**
 * @typedef {Object} BaiduDuration
 * @property {string} text A string representation of the duration value.
 * @property {number} value The duration in seconds.
 */

/**
 * @typedef {Object} BaiduDistance
 * @property {string} text A string representation of the distance value.
 * @property {number} value The distance in meters.
 */

/**
 * Google DirectionsStep-like implementation to work with Baidu
 * @private
 */

/**
 * Gets step implementation.
 * @private
 * @param {google.maps.DirectionsStep} step array of points or DirectionsStep depending on the current loaded library (Google/Baidu)
 * @param {BMap.RouteType} routeType
 * @returns {google.maps.DirectionsStep}
 */
function getDirectionsStep(step, routeType = null) {
    return step;
}

module.exports = getDirectionsStep;
